<template lang="pug">
  .course-list-filter-block
    v-expand-transition
      .mb-7(v-if="activeFilters.length")
        p.caption Установленные фильтры:
        v-chip.mr-3(
          v-for="(filter, idx) in activeFilters"
          :key="idx"
          color="secondary"
          :close="$user.data.is_local ? true :  filter.key !== 'search[region]'"
          small
          clearable
          @click:close="removeActiveFilter(filter.key)"
        )
          span(v-if="filter.label").mr-1 {{ filter.label }} -
          span {{ filter.valueHumanized }}
    div
      .d-flex.fill-width.align-center
        v-text-field.flex-grow-1.search-field(
          :value="filters['search[name]']"
          placeholder="Поиск курсов"
          flat solo
          clearable
          hide-details
          @keyup.enter="emitFilters"
          @input="filters['search[name]'] = $event"
        )
          template(#append)
            v-btn.my-2(
              depressed
              rounded text
              :icon="$vuetify.breakpoint.xsOnly"
              @click="emitFilters"
            )
              v-icon mdi-magnify
              span.hidden-xs-only.ml-2 Поиск
            v-btn.my-2(@click.stop="drawer = true" icon)
              v-icon mdi-tune

    v-navigation-drawer(
      app
      v-model="drawer" temporary :width="isMobile ? '100%' : '600'" right fixed
    )
      v-card(flat).fill-height.d-flex.flex-column
        v-card-text.fill-height
          v-btn(text color="primary" @click="drawer = false;").ml-n2.px-2
            v-icon(left) mdi-arrow-left
            span Назад
          .d-flex.align-center
            v-card-title.black--text.text-h5.px-0: strong Фильтры
            v-btn(
              @click="clearFilters" small depressed rounded text
            ).ml-auto Сбросить
          .px-2.pt-6
            v-row
              v-col(v-if="!($user.data.is_local && !$user.isTeache)" cols=12)
                v-select.search-field(
                  @keyup.enter="emitFilters"
                  v-model="filters['search[type]']"
                  v-bind="typeAttrs"
                  label="Тип курса"
                  hide-details
                  clearable
                  flat solo
                  :outlined="$vuetify.theme.dark"
                  multiple
                  return-object
                )
                  template(#item="{ item, attrs, on }")
                    v-list-item(v-bind="attrs" v-on="on")
                      v-list-item-content {{ item.text }}

              v-col(v-if="!$user.data.is_local && !$user.isTeacher || $user.isOrganization" cols=12)
                v-select.search-field(
                  v-model="filters['search[direction]']"
                  :items="directions"
                  item-text="name"
                  hide-details
                  item-value="id"
                  :loading="directionsLoading"
                  label="Направленность"
                  clearable
                  flat solo
                  return-object
                  :outlined="$vuetify.theme.dark"
                  @keyup.enter="emitFilters"
                  @click:clear="removeActiveFilter('search[direction]')"
                )
              v-col(cols=12 v-if="!$user.data.is_local && !$user.isTeacher || $user.isOrganization")
                v-select.search-field(
                  v-model="filters['search[activity]']"
                  :items="activities"
                  item-text="name"
                  hide-details
                  item-value="id"
                  :disabled="!filters['search[direction]']"
                  :loading="activitiesLoading"
                  label="Вид деятельности"
                  clearable
                  flat solo
                  return-object
                  :outlined="$vuetify.theme.dark"
                  @keyup.enter="emitFilters"
                )
              v-col(cols=12 v-if="$user.data.is_local && !$user.isTeacher")
                server-data(
                  :method="$api.dir.regions"
                  search-field-name="search[name]"
                  v-slot="{ selectProps, search, loadMoreItems }"
                )
                  v-autocomplete-more.search-field(
                    v-model="filters['search[region]']"
                    v-bind="selectProps"
                    :items="selectProps.items.length ? selectProps.items : [initial.region]"
                    item-value="code"
                    label="Регион"
                    clearable
                    hide-details
                    flat solo
                    :outlined="$vuetify.theme.dark"
                    return-object
                    @update:search-input="search"
                    @load-more-items="loadMoreItems"
                    @keyup.enter="emitFilters"
                  )
              v-col(cols=12 v-if="$user.data.is_local")
                server-data(
                  :method="$api.dir.municipalities"
                  search-field-name="search[name]"
                  :query=`{
                    'search[region]': filters['search[region]'] && filters['search[region]'].id
                  }`
                  v-slot="{ selectProps, search, loadMoreItems }"
                )
                  v-autocomplete-more.search-field(
                    v-model="filters['search[municipality]']"
                    label="Муниципалитет"
                    v-bind="selectProps"
                    :items="selectProps.items.length ? selectProps.items : [initial.municipality]"
                    :disabled="isMunicipalityDisabled"
                    clearable
                    hide-details
                    flat solo
                    :outlined="$vuetify.theme.dark"
                    return-object
                    @keyup.enter="emitFilters"
                    @update:search-input="search"
                    @load-more-items="loadMoreItems"
                  )
              v-col(cols=12)
                server-data(
                  :method="$api.dir.organizations"
                  search-field-name="search[short_name]"
                  v-slot="{ selectProps, search, loadMoreItems }"
                )
                  v-autocomplete-more.search-field(
                    v-model="filters['search[organization]']"
                    v-bind="selectProps"
                    label="Организация"
                    item-text="short_name"
                    hide-details
                    clearable
                    flat solo
                    return-object
                    :outlined="$vuetify.theme.dark"
                    @keyup.enter="emitFilters"
                    @update:search-input="search"
                    @load-more-items="loadMoreItems"
                  )
              v-col(cols=12 v-if="!$user.data.is_local && !$user.isTeacher")
                v-text-field.mb-4.search-field(
                  @keyup.enter="emitFilters"
                  v-model="filters['search[age_min]']"
                  label="Минимальный возраст"
                  hide-details
                  flat solo
                  clearable
                  :outlined="$vuetify.theme.dark"
                )
              v-col(cols=12 v-if="!$user.data.is_local && $user.isTeacher")
                v-select.search-field(
                  v-model="duration"
                  :items="durations"
                  hide-details
                  label="Объем часов"
                  clearable
                  flat solo
                  :outlined="$vuetify.theme.dark"
                  )

        v-card-actions
          v-btn(
            color="success"
            rounded depressed block large
            @click="emitFilters(); setSearchLocation(); drawer = false"
          )
            v-icon(left) mdi-magnify
            | Найти
</template>

<script>
import { mapGetters } from 'vuex';

import SystemService from '@/services/API/SystemService';
// import CourseService from '@/services/API/CourseService';
import DirectoryService from '@/services/API/DirectoryService';

const FILTER_LABELS = {
  'search[type]': 'Тип',
  'search[name]': 'Поиск',
  'search[code]': 'Код',
  'search[direction]': 'Направленность',
  'search[level]': 'Уровень',
  'search[age_min]': 'Минимальный возраст',
  'search[teacher]': 'Преподаватель',
};

const FILTER_HUMANIZER = {
  'search[organization]': (val) => val.short_name,
  'search[type]': (val) => val.text,
  'search[direction]': (val) => val.name,
  'search[activity]': (val) => val.name,
  'search[level]': (val) => val.title,
  'search[teacher]': (val) => val.name,
  'search[region]': (val) => val.name,
  'search[municipality]': (val) => val.name,
  'search[duration]': (val) => {
    const [start, end] = val.split(',');
    return `от ${start} до ${end} часов`;
  },
};

const FILTER_QUERY_SERIALIZER = {
  'search[organization]': (val) => val.id,
  'search[type]': (val) => val.value,
  'search[direction]': (val) => val.id,
  'search[activity]': (val) => val.id,
  'search[level]': (val) => val.value,
  'search[teacher]': (val) => val.id,
  'search[region]': (val) => val.code,
  'search[municipality]': (val) => val.id,
};

const FILTER_QUERY_TO_INTERNAL_VALUE = {
  'search[region]': (id) => DirectoryService.regionShow(id).then(({ data }) => data.data),
  'search[municipality]': (id) => DirectoryService.municipalityShow(id).then(({ data }) => data.data),
  'search[organization]': (id) => DirectoryService.organizationShow(id).then(({ data }) => data.data),
  'search[activity]': (id) => DirectoryService.programActivity(id).then(({ data }) => data.data),
  'search[direction]': (id) => DirectoryService.programDirectionShow(id).then(({ data }) => data.data),
};

export default {
  name: 'CourseListFilterBlock',
  props: {
    loading: { type: Boolean, default: false },
    noMountedEmit: { type: Boolean, default: false },
    initial: {
      type: Object,
      default: () => ({
        region: {},
        municipality: {},
      }),
    },
  },
  data() {
    return {
      drawer: false,
      directions: [],
      activities: [],
      maxDuration: 0,
      directionsLoading: false,
      activitiesLoading: false,
      duration: null, // Диапазон длительности курса, напр. [0, 200]
      regionId: null,
      durations: [
        { text: 'до 36', value: [0, 36] },
        { text: 'от 36 до 72', value: [36, 72] },
        { text: 'от 72 до 144', value: [72, 144] },
        { text: '144 и более', value: [144, 1000] },
      ],
      filters: {
        'search[type]': null,
        'search[name]': null,
        'search[code]': null,
        'search[direction]': null,
        'search[activity]': null,
        'search[level]': null,
        'search[age_min]': null,
        'search[teacher]': null,
        'search[duration]': null,
        'search[region]': null,
        'search[municipality]': null,
        'search[organization]': null,
      },
    };
  },
  computed: {
    ...mapGetters(['courseResources']),
    isTeacher() {
      const { $user } = this;
      return $user.isTeacher && !$user.studentMode;
    },
    isMobile() {
      return !this.$vuetify.breakpoint.smAndUp;
    },
    typeAttrs() {
      const data = this.$conf.constantListProps('COURSE_TYPES');
      const {
        general,
        qualification,
        professional,
        personal,
      } = this.$conf.COURSE_TYPES;
      const filtered = {
        [this.$conf.ROLES.organization.value]: [general, qualification, professional, personal],
        [this.$conf.ROLES.operator.value]: [general, qualification, professional, personal],
        [this.$conf.ROLES.department.value]: [general, qualification, professional, personal],
        [this.$conf.ROLES.teacher.value]: this.$user.data.is_local
          ? [qualification, professional, personal] : [qualification, professional, personal],
        [this.$conf.ROLES.student.value]: this.$user.data.is_local
          ? [qualification, professional, personal] : [general],
        [this.$conf.ROLES.listener.value]: this.$user.data.is_local
          ? [qualification, professional, personal] : [qualification],
      };
      return {
        ...data,
        items: data.items.filter(
          (el) => filtered[this.$user.data.role].includes(el.value),
        ),
        // .filter((el) => (this.$user.data.is_local ? [2, 3, 4].includes(el.value) : true)),
      };
    },
    isMunicipalityDisabled() {
      return !this.region;
    },
    search() {
      return this.filters['search[name]'];
    },
    region() {
      return this.filters['search[region]'];
    },
    direction() {
      return this.filters['search[direction]'];
    },
    activeFilters() {
      const getFilterObject = (key, value) => {
        const valueHumanized = (FILTER_HUMANIZER[key]
            && FILTER_HUMANIZER[key](value)) || value;

        const valueQuery = (FILTER_QUERY_SERIALIZER[key]
            && FILTER_QUERY_SERIALIZER[key](value)) || value;
        return {
          label: FILTER_LABELS[key],
          key,
          value,
          valueHumanized,
          valueQuery,
        };
      };
      return Object.entries(this.filters)
        .reduce((acc, [key, value]) => {
          if (value) {
            if (Array.isArray(value)) {
              value.forEach((el) => acc.push(getFilterObject(key, el)));
            } else acc.push(getFilterObject(key, value));
          }
          return acc;
        }, []);
    },
  },
  watch: {
    duration(val) {
      this.filters['search[duration]'] = val ? val.join(',') : null;
    },

    drawer(val) {
      if (val) this.init();
    },
    search(val) {
      this.$emit('search', val);
    },
    region(val) {
      if (!val) this.filters['search[municipality]'] = null;
    },
    direction(val) {
      return val && this.loadActivities();
    },
  },
  mounted() {
    if (this.$user.isAuthenticated && !this.$user.data.is_local && this.$user.isStudent) {
      if (this.initial.region.id) {
        this.filters['search[region]'] = this.initial.region;
      }
    }

    this.setupQuery();
    if (!this.noMountedEmit) this.emitFilters();
  },
  methods: {
    loadDirections() {
      if (this.directions.length) return;
      this.directionsLoading = true;
      this.$rHandler(
        SystemService.getDirections(),
        (r) => {
          this.directions = r.data.data;
          this.directionsLoading = false;
        },
      );
    },
    loadActivities() {
      const params = {
        'search[direction_id]': this.filters['search[direction]']?.id,
        'per-page': 200,
      };
      this.activitiesLoading = true;
      this.$rHandler(
        SystemService.getActivities(params),
        (r) => {
          this.activities = r.data.data;
          this.activities.unshift({ name: 'Все', id: null });
          this.activitiesLoading = false;
        },
      );
    },
    /**
     * Вызывается при поиске курсов если заполнены фильтры региона и муниципалитета,
     * для записи их в localStorage для дальнейшего использования в фильтрах
     */
    setSearchLocation() {
      if (this.$user.isAuthenticated && this.filters['search[region]'] && this.filters['search[municipality]']) {
        const searchLocation = {
          region: this.filters['search[region]'],
          municipality: this.filters['search[municipality]'],
        };

        localStorage.setItem('CoursesSearchLocation', JSON.stringify(searchLocation));
      }
    },
    removeActiveFilter(key) {
      this.filters[key] = null;
      if (key === 'search[region]') { this.filters['search[municipality]'] = null; }
      if (key === 'search[direction]') { this.filters['search[activity]'] = null; }
      this.emitFilters();
    },
    setupQuery() {
      const query = { ...this.$route.query };
      Object.entries(query).forEach(([key, value]) => {
        const toInternalFunc = FILTER_QUERY_TO_INTERNAL_VALUE[key];

        if (toInternalFunc) toInternalFunc(value).then((val) => { this.filters[key] = val; });
        this.filters[key] = value;
      });
    },
    emitFilters() {
      this.$emit(
        'filters:update',
        this.activeFilters.reduce((acc, i) => ({ ...acc, [i.key]: i.valueQuery }), {}),
      );
    },
    init() {
      this.loadDirections();
    },
    clearFilters() {
      this.filters = {
        'search[type]': null,
        'search[name]': null,
        'search[code]': null,
        'search[direction]': null,
        'search[activity]': null,
        'search[level]': null,
        'search[age_min]': null,
        'search[teacher]': null,
        'search[duration]': null,
      };
    },
  },
};
</script>

<style lang="scss" scoped>
  .v-expansion-panels {
    position: sticky;
    top: 70px;
    box-shadow: 0 8px 24px -19px rgba(0, 0, 0, 0.8);
    border: 1px solid #f5f5f5;
    background-color: #fff;
    border-radius: 8px;

    &.theme--dark {
      background-color: #1e1e1e;
      border: 1px solid #222;
    }
  }

</style>
